import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function WorkoutModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="btn-outline-light" variant="danger" size='sm' onClick={handleShow}>
        Info
      </Button>

      <Modal show={show} onHide={handleClose} animation={true} size='lg' aria-labelledby='contained-modal-title-vcenter' centered style={{backgroundColor:'black'}}>
        <Modal.Header  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <Modal.Title style={{backgroundColor:'black', border:'none', color:'white'}}>One-Time 1-Month Workout Regimen</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D", color:'white'}}>
            <h2>
              <u>                
                Custom Training Plan
              </u>
            </h2>
            <p>
               A full 4-week program tailored to your goals, fitness level, and schedule.
            </p>
            <h2>
              <u>                
                Exercise Demonstrations & Notes
              </u>
            </h2>
            <p>
              Detailed video movement instructions with rep,sets, and weight logs to keep track over all metrics.
            </p>
            <h2>
              <u>                
                Progression Structure
              </u>
            </h2>
            <p>Smart programming that evolves week to week for steady results.</p>
            <h2>
              <u>                
                Equipment Adaptability
              </u>
            </h2>
            <p>Options for both gym and home setups with minimal or full equipment.</p>
            <h2>
              <u>                
                Professional Insight
              </u>
            </h2>
            <p>Designed using proven training methods focused on progressive overload, recovery, and functional strength.</p>
            
            
            <p>This plan gives you the structure and clarity you need to train effectively — whether you’re starting fresh or breaking through a plateau.</p>
            <p>Your transformation starts with one month of focused, intelligent training.</p>
            <h3 className='pt-3'>Train. Eat. Evolve.</h3>
           
        </Modal.Body>
        <Modal.Footer style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <h5 className='col' style={{color:"white"}}>
            Price: $100.00
          </h5>
          <Button  variant="danger"  onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default WorkoutModal;